import { render, staticRenderFns } from "./videoContainer.vue?vue&type=template&id=03e99eee&scoped=true"
import script from "./videoContainer.vue?vue&type=script&lang=js"
export * from "./videoContainer.vue?vue&type=script&lang=js"
import style0 from "./videoContainer.vue?vue&type=style&index=0&id=03e99eee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../globalsearch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e99eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/globalsearch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e99eee')) {
      api.createRecord('03e99eee', component.options)
    } else {
      api.reload('03e99eee', component.options)
    }
    module.hot.accept("./videoContainer.vue?vue&type=template&id=03e99eee&scoped=true", function () {
      api.rerender('03e99eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "youtubewidget/src/components/videoContainer.vue"
export default component.exports